const normalizeRegistration = (blockType, registration) => {
    if (typeof registration === 'function') {
        return { blockType, renderer: registration };
    }
    return {
        ...registration,
        blockType: registration.blockType || blockType,
    };
};
export const createBlockRendererRegistry = (initialRenderers = {}) => {
    const renderers = new Map();
    Object.entries(initialRenderers).forEach(([blockType, renderer]) => {
        if (renderer)
            renderers.set(blockType, normalizeRegistration(blockType, renderer));
    });
    return {
        get: (blockType) => renderers.get(blockType),
        has: (blockType) => renderers.has(blockType),
        set: (blockType, renderer) => {
            renderers.set(blockType, normalizeRegistration(blockType, renderer));
        },
        delete: (blockType) => {
            renderers.delete(blockType);
        },
    };
};
export const registerBlockRenderer = (registry, blockType, renderer) => {
    registry.set(blockType, renderer);
    return () => registry.delete(blockType);
};
const isRegistry = (source) => typeof source.get === 'function';
export const getBlockRenderer = (source, blockType) => {
    if (isRegistry(source))
        return source.get(blockType);
    const registration = source[blockType];
    return registration ? normalizeRegistration(blockType, registration) : undefined;
};
export const isLikelyPluginBlockType = (blockType) => /[A-Z]/.test(blockType) || /^ext:/i.test(blockType) || /[:._-]plugin/i.test(blockType);
export const resolveBlockRenderer = (blockType, registry) => {
    const definition = getBlockRenderer(registry, blockType);
    if (definition)
        return { renderer: definition.renderer, definition, reason: 'known' };
    return {
        renderer: null,
        definition: null,
        reason: isLikelyPluginBlockType(blockType) ? 'plugin_renderer_missing' : 'renderer_missing',
    };
};
